const exportOptions = [
  { key: 'PDF', text: 'PDF', value: 'PDF' },
  { key: 'Excel', text: 'Excel', value: 'Excel' }
]

export {exportOptions}
